import { render, staticRenderFns } from "./ClientLoginPage.vue?vue&type=template&id=473384bc&scoped=true"
import script from "./ClientLoginPage.vue?vue&type=script&lang=js"
export * from "./ClientLoginPage.vue?vue&type=script&lang=js"
import style0 from "./ClientLoginPage.vue?vue&type=style&index=0&id=473384bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473384bc",
  null
  
)

export default component.exports